module.exports = __webpack_public_path__ + "img/gpt-addin-thumbnail.106b4de5.png";